import {Component, Inject, OnInit} from '@angular/core';
import {TEST_VALIDATORS} from '../../../../constants/validators';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TestService} from '../../../services/api/test.service';
import {Test} from '../../../data/models/test/test';

@Component({
  selector: 'app-test-rename-dialog',
  templateUrl: './test-rename-dialog.component.html',
  styleUrls: ['./test-rename-dialog.component.css']
})
export class TestRenameDialogComponent implements OnInit {

  test: Test;
  testForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TestRenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      test: Test,
    },
    private testService: TestService,
  ) {
    this.test = data.test;
    this.testForm = this.fb.group({
      name: [this.test.name, TEST_VALIDATORS.NAME],
    });
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.testForm.valid) {
      this.testService.updateTest(this.test.id, {
        name: this.testForm.controls.name.value,
      })
        .then(test => this.dialogRef.close(test));
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
